// // export * from './event'
// import { 
//   MASTER_LOCALE_DATA_LOADED, 
//   MASTER_LOCALE_CHANGED, 
//   MICRO_LOCALE_CHANGED, 
//   MICRO_LOCALE_DATA_REQUEST,
//   getEventNameForLoadModuleDataFromMaster,
// } from './event'

// const INTERNAL_CODE: Record<number, string> = {
//   500: '服务器发生错误，请检查服务器',
//   401: '无权限访问',
//   405: '请求方式错误',
//   404: '请求接口不存在',
//   409: '您的账号已在其他设备端登录，您被迫退出，若这不是您的操作，请及时修改密码，保护您的账号安全',
//   200: '服务器成功返回请求的数据。',
//   201: '新建或修改数据成功',
//   202: '一个请求已经进入后台排队（异步任务）',
//   204: '删除数据成功',
//   400: '发出的请求体有错误，服务器没有进行新建或修改数据的操作',
//   403: '用户得到授权，但是访问是被禁止的',
//   410: '请求的资源被永久删除，且不会再得到的',
//   422: '当创建一个对象时，发生一个验证错误',
//   502: '网关错误',
//   503: '服务不可用，服务器暂时过载或维护',
//   504: '网关超时',
// }

// const getUrls: any = (
//   { proCode }: Record<string, any>,
//   extraProps?: Record<string, any>,
// ) => {
//   const actionTime = new Date().getTime()

//   return {
//     // 核销类
//     QR: `/goods/template/QR?proCode=${proCode}&clearCache=1&equityCouponCode=${
//       extraProps?.equityCouponCode || ''}`,
//     // 非核销类 start
//     MG: `/vvip?proCode=${proCode}&clearCache=1&equityCouponCode=${
//       extraProps?.equityCouponCode || ''
//     }&assign=${extraProps?.assign || ''}`,
//     GC: `/goods/loading?proCode=${proCode}&categoryType=GC&equityCouponCode=${
//       extraProps?.equityCouponCode || ''
//     }`,
//     GV: `/goods/loading?proCode=${proCode}&categoryType=GV&equityCouponCode=${
//       extraProps?.equityCouponCode || ''
//     }&assign=${extraProps?.assign || ''}`,
//     LS: `/limousine?proCode=${proCode}&clearCache=1&equityCouponCode=${
//       extraProps?.equityCouponCode || ''
//     }&assign=${extraProps?.assign || ''}`,
//     SN: `/limousine/template/SN?proCode=${proCode}&clearCache=1&equityCouponCode=${
//       extraProps?.equityCouponCode || ''
//     }&assign=${extraProps?.assign || ''}`,
//     CC: `/limousine/template/CC?proCode=${proCode}&clearCache=1&equityCouponCode=${
//       extraProps?.equityCouponCode || ''}`,
//     JD: `/goods/loading?proCode=${proCode}&categoryType=JD&actionTime=${actionTime}&equityCouponCode=${
//       extraProps?.equityCouponCode || ''
//     }`,
//     EQ: `/goods/equity/detail?proCode=${proCode}`,
//     MX: `/goods/equity/detail?proCode=${proCode}`,
//     COP: `/goods/equity/detail?proCode=${proCode}`,
//     SC: `/goods/loading?proCode=${proCode}&categoryType=SC&equityCouponCode=${
//       extraProps?.equityCouponCode || ''
//     }`,
//     SW: `/goods/loading?proCode=${proCode}&categoryType=SW&equityCouponCode=${
//       extraProps?.equityCouponCode || ''
//     }&assign=${extraProps?.assign || ''}`,
//     CP: `/goods/loading?proCode=${proCode}&categoryType=CP`,
//     TPS: `/goods/loading?proCode=${proCode}&categoryType=TPS&actionTime=${actionTime}&equityCouponCode=${
//       extraProps?.equityCouponCode || ''
//     }`,
//     // TPS: `/goods/template/TPS/list?proCode=${proCode}&clearCache=1&actionTime=${actionTime}`,
//     LCG: `/goods/loading?proCode=${proCode}&categoryType=LCG&equityCouponCode=${
//       extraProps?.equityCouponCode || ''
//     }`,
//     OCG: `/goods/loading?proCode=${proCode}&categoryType=OCG&equityCouponCode=${
//       extraProps?.equityCouponCode || ''
//     }&assign=${extraProps?.assign || ''}`,
//     SCG: `/goods/loading?proCode=${proCode}&categoryType=SCG&equityCouponCode=${
//       extraProps?.equityCouponCode || ''
//     }&assign=${extraProps?.assign || ''}`,
//     SSC: `/goods/loading?proCode=${proCode}&categoryType=SSC&equityCouponCode=${
//       extraProps?.equityCouponCode || ''
//     }&assign=${extraProps?.assign || ''}`,
//     GQR: `/goods/loading?proCode=${proCode}&categoryType=GQR&equityCouponCode=${
//       extraProps?.equityCouponCode || ''
//     }&assign=${extraProps?.assign || ''}`,
//     // 非核销类 end
//   }
// }

// const EXCHANGE_CODE_BACK_URL = 'exchangeCodeBackUrl'
// const EXCHANGE_CODE_NEED_BACK = 'EXCHANGE_CODE_NEED_BACK'

// const CUSTOMIZE_LOGIN_REDIRECT_URL = 'customizeLoginRedirectUrl'

// export default {
//   MASTER_LOCALE_DATA_LOADED, 
//   MASTER_LOCALE_CHANGED, 
//   MICRO_LOCALE_CHANGED, 
//   MICRO_LOCALE_DATA_REQUEST,
//   getEventNameForLoadModuleDataFromMaster,
//   INTERNAL_CODE,
//   getUrls,
//   EXCHANGE_CODE_BACK_URL,
//   EXCHANGE_CODE_NEED_BACK,
//   CUSTOMIZE_LOGIN_REDIRECT_URL,
// }


export * from './event'

export const INTERNAL_CODE: Record<number, string> = {
  500: '服务器发生错误，请检查服务器',
  401: '无权限访问',
  405: '请求方式错误',
  404: '请求接口不存在',
  409: '您的账号已在其他设备端登录，您被迫退出，若这不是您的操作，请及时修改密码，保护您的账号安全',
  200: '服务器成功返回请求的数据。',
  201: '新建或修改数据成功',
  202: '一个请求已经进入后台排队（异步任务）',
  204: '删除数据成功',
  400: '发出的请求体有错误，服务器没有进行新建或修改数据的操作',
  403: '用户得到授权，但是访问是被禁止的',
  410: '请求的资源被永久删除，且不会再得到的',
  422: '当创建一个对象时，发生一个验证错误',
  502: '网关错误',
  503: '服务不可用，服务器暂时过载或维护',
  504: '网关超时',
}

export const getUrls: any = (
  { proCode }: Record<string, any>,
  extraProps?: Record<string, any>,
) => {
  const actionTime = new Date().getTime()

  return {
    // FT FastTrack V2 prebooking 预约类
    FT: `/goods/template/FT/product?proCode=${proCode}&clearCache=1&equityCouponCode=${
      extraProps?.equityCouponCode || ''}`,
    // 核销类
    QR: `/goods/template/QR?proCode=${proCode}&clearCache=1&equityCouponCode=${
      extraProps?.equityCouponCode || ''}`,
    // 非核销类 start
    MG: `/vvip?proCode=${proCode}&clearCache=1&equityCouponCode=${
      extraProps?.equityCouponCode || ''
    }&assign=${extraProps?.assign || ''}`,
    GC: `/goods/loading?proCode=${proCode}&categoryType=GC&equityCouponCode=${
      extraProps?.equityCouponCode || ''
    }`,
    GV: `/goods/loading?proCode=${proCode}&categoryType=GV&equityCouponCode=${
      extraProps?.equityCouponCode || ''
    }&assign=${extraProps?.assign || ''}`,
    LS: `/limousine?proCode=${proCode}&clearCache=1&equityCouponCode=${
      extraProps?.equityCouponCode || ''
    }&assign=${extraProps?.assign || ''}&source=equity`,
    SN: `/limousine/template/SN?proCode=${proCode}&clearCache=1&equityCouponCode=${
      extraProps?.equityCouponCode || ''
    }&assign=${extraProps?.assign || ''}&source=equity`,
    CC: `/limousine/template/CC?proCode=${proCode}&clearCache=1&equityCouponCode=${
      extraProps?.equityCouponCode || ''}&source=equity`,
    DJ: `/limousine/template/DJ?proCode=${proCode}&clearCache=1&equityCouponCode=${
      extraProps?.equityCouponCode || ''}&source=equity`,
    JD: `/goods/loading?proCode=${proCode}&categoryType=JD&actionTime=${actionTime}&equityCouponCode=${
      extraProps?.equityCouponCode || ''
    }`,
    EQ: `/goods/equity/detail?proCode=${proCode}`,
    MX: `/goods/equity/detail?proCode=${proCode}`,
    COP: `/goods/equity/detail?proCode=${proCode}`,
    SC: `/goods/loading?proCode=${proCode}&categoryType=SC&equityCouponCode=${
      extraProps?.equityCouponCode || ''
    }`,
    SW: `/goods/loading?proCode=${proCode}&categoryType=SW&equityCouponCode=${
      extraProps?.equityCouponCode || ''
    }&assign=${extraProps?.assign || ''}`,
    CP: `/goods/loading?proCode=${proCode}&categoryType=CP`,
    TPS: `/goods/loading?proCode=${proCode}&categoryType=TPS&actionTime=${actionTime}&equityCouponCode=${
      extraProps?.equityCouponCode || ''
    }`,
    // TPS: `/goods/template/TPS/list?proCode=${proCode}&clearCache=1&actionTime=${actionTime}`,
    LCG: `/goods/loading?proCode=${proCode}&categoryType=LCG&equityCouponCode=${
      extraProps?.equityCouponCode || ''
    }`,
    OCG: `/goods/loading?proCode=${proCode}&categoryType=OCG&equityCouponCode=${
      extraProps?.equityCouponCode || ''
    }&assign=${extraProps?.assign || ''}`,
    SCG: `/goods/loading?proCode=${proCode}&categoryType=SCG&equityCouponCode=${
      extraProps?.equityCouponCode || ''
    }&assign=${extraProps?.assign || ''}`,
    SSC: `/goods/loading?proCode=${proCode}&categoryType=SSC&equityCouponCode=${
      extraProps?.equityCouponCode || ''
    }&assign=${extraProps?.assign || ''}`,
    GQR: `/goods/loading?proCode=${proCode}&categoryType=GQR&equityCouponCode=${
      extraProps?.equityCouponCode || ''
    }&assign=${extraProps?.assign || ''}`,
    // 非核销类 end
  }
}

export const EXCHANGE_CODE_BACK_URL = 'exchangeCodeBackUrl'
export const EXCHANGE_CODE_NEED_BACK = 'EXCHANGE_CODE_NEED_BACK'

export const CUSTOMIZE_LOGIN_REDIRECT_URL = 'customizeLoginRedirectUrl'

